'use client';

/**
 * 마켓 랭킹의 표시 조각 — **구현은 `components/cmui/rankings/ranking-badges` 하나다.**
 *
 * 이 파일은 마켓 화면의 열세 호출부가 쓰던 이름을 그대로 유지하는 통로다 — 새 호출부는 cmui 를 직접 부른다.
 */
export { Tag, RankBadge, RankChangeBadge } from 'src/components/cmui/rankings/ranking-badges';
